module.exports = __webpack_public_path__ + "img/GAME_MULTI OMOK1.9b313ac5.jpg";